var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL0_wght400_GRAD0_opsz48",
    d: "M109.411-837.651l-8.452-8.452a2.581,2.581,0,0,0-1.9-.776,2.727,2.727,0,0,0-1.984.863,2.581,2.581,0,0,0-.776,1.9,2.581,2.581,0,0,0,.776,1.9L107.6-831.614a2.483,2.483,0,0,0,1.811.776,2.483,2.483,0,0,0,1.811-.776l20.614-20.614a2.727,2.727,0,0,0,.863-1.984,2.727,2.727,0,0,0-.863-1.984,2.769,2.769,0,0,0-2.027-.733,2.787,2.787,0,0,0-1.941.819ZM114.5-811a33.381,33.381,0,0,1-13.369-2.717,34.994,34.994,0,0,1-11-7.417,34.994,34.994,0,0,1-7.417-11A33.382,33.382,0,0,1,80-845.5a33.6,33.6,0,0,1,2.717-13.455,34.478,34.478,0,0,1,7.417-10.954,35.365,35.365,0,0,1,11-7.374A33.382,33.382,0,0,1,114.5-880a33.594,33.594,0,0,1,13.455,2.717,34.839,34.839,0,0,1,10.954,7.374,34.84,34.84,0,0,1,7.374,10.954A33.6,33.6,0,0,1,149-845.5a33.382,33.382,0,0,1-2.717,13.369,35.366,35.366,0,0,1-7.374,11,34.479,34.479,0,0,1-10.954,7.417A33.594,33.594,0,0,1,114.5-811Zm0-5.175a28.218,28.218,0,0,0,20.786-8.582,28.332,28.332,0,0,0,8.539-20.743,28.29,28.29,0,0,0-8.539-20.786,28.291,28.291,0,0,0-20.786-8.539,28.332,28.332,0,0,0-20.743,8.539A28.218,28.218,0,0,0,85.175-845.5a28.26,28.26,0,0,0,8.582,20.743A28.26,28.26,0,0,0,114.5-816.175ZM114.5-845.5Z",
    transform: "translate(-80 880)",
    fill: "#53aa68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d3509e06c6dbfa6e95d93119f1cfa637.svg";
export { ForwardRef as ReactComponent };